module.exports = __webpack_public_path__ + "620812bc51ae9a219c83a8335b756263.jpg";